export default __webpack_public_path__ + "static/media/PhysiotherapyIcon.4d097fd9.svg";